import resourceService from '@/services/resource.service'

/**
 * Utility function to delete temporary resources with copies/ prefix
 * This should be called after successfully loading content to clean up temporary files
 */
export const cleanupTemporaryResources = async (uuid: string, key: string, fileName?: string): Promise<void> => {
  try {
    await resourceService.deleteTemporaryResource({ uuid, key: `copies/${key}/${fileName}` })
    // eslint-disable-next-line no-console
    console.log(`Successfully cleaned up temporary resource with key: ${key}`)
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('Failed to cleanup temporary resource:', error)
    // Don't throw error to avoid breaking the main flow
    // The cleanup is not critical for the user experience
  }
}
